import ReactGA from "react-ga"
import { trackingId } from "../../../actions/config";

export const initGA = () => {
  ReactGA.initialize(trackingId)
}

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname })
  ReactGA.pageview(window.location.pathname)
}

export const trackingEvent = (category = "", label = "") => {
  ReactGA.event({
    category: category,
    action: "Click",
    label: label
  })
}
